import React from 'react';
import ContentLoader from "react-content-loader"

export const ServiceListImageLoader = () => (
  <ContentLoader
    height={163}
    width={298}
    speed={2}
    primaryColor="#ecebeb"
    secondaryColor="#fff"
  >
    <rect x="0" y="0" rx="0" ry="0" width="298" height="163" />
  </ContentLoader>
)

